import { render, staticRenderFns } from "./AssociatedEntities.vue?vue&type=template&id=2e0a16e7&scoped=true"
import script from "./AssociatedEntities.vue?vue&type=script&lang=js"
export * from "./AssociatedEntities.vue?vue&type=script&lang=js"
import style0 from "./AssociatedEntities.vue?vue&type=style&index=0&id=2e0a16e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a16e7",
  null
  
)

export default component.exports